__webpack_require__.p = "https://d16ocmgiaih8r7.cloudfront.net/cases/_next/";